__turbopack_context__.v({
  "authorBio": "cq9SQq_authorBio",
  "bioContent": "cq9SQq_bioContent",
  "body": "cq9SQq_body",
  "contact": "cq9SQq_contact",
  "media": "cq9SQq_media",
  "name": "cq9SQq_name",
  "nameLink": "cq9SQq_nameLink",
  "photo": "cq9SQq_photo",
  "role": "cq9SQq_role",
});
